import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Teams({ seasonId }) {
  const [teams, setTeams] = useState([]);
  const [contacts, setContacts] = useState({}); // { teamId: [contacts] }

  useEffect(() => {
    if (!seasonId) return;
    fetch(`/api/teams?season_id=${seasonId}`)
      .then(res => res.json())
      .then(data => {
        setTeams(Array.isArray(data) ? data : []);
        // Načti kontakty pro každý tým
        data.forEach(team => {
          fetch(`/api/teams/${team.id}/contacts`)
            .then(res => res.json())
            .then(c => setContacts(prev => ({ ...prev, [team.id]: Array.isArray(c) ? c : [] })));
        });
      });
  }, [seasonId]);

  return (
    <div>
      <h2 className="text-center mb-4">Týmy</h2>
      <div className="row g-4 justify-content-center">
        {teams.map(team => (
          <div key={team.id} className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <div className="card shadow-sm w-100">
              <div className="card-body">
                <div className="d-flex align-items-center gap-3 mb-3">
                  {team.logo && (
                    <img
                      src={`/logos/${team.logo.replace(/^logos[\\/]/, '')}`}
                      alt={team.name}
                      className="border bg-white rounded me-2"
                      style={{height:32, objectFit:'contain'}}
                    />
                  )}
                  <h5 className="card-title mb-0">
                    <Link to={`/teams/${team.id}`} className="btn btn-link p-0 fw-bold text-decoration-none">
                      {team.name}
                    </Link>
                  </h5>
                </div>
                <div>
                  <strong>Kontaktní osoby:</strong>
                  <ul className="ps-3 mt-2 mb-0">
                    {(contacts[team.id]||[]).length === 0 && <li className="text-muted">Žádné kontaktní osoby</li>}
                    {(contacts[team.id]||[]).map(c => (
                      <li key={c.id}>
                        <div><strong>{c.name}</strong></div>
                        {c.phone && <div>Tel: {c.phone}</div>}
                        {c.email && <div>Email: {c.email}</div>}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Teams;
